import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/logo.png'
import _imports_1 from '../assets/images/3d.png'


const _withScopeId = n => (_pushScopeId("data-v-44f9c9ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cs-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-end mb-6 px-2" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-bold md:text-4xl" }, "견적서")
], -1))
const _hoisted_3 = { class: "w-full h-full md:flex" }
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center text-xl font-bold" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fi fi-rr-cloud-upload-alt text-xl" }),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-1" }, "STL, STP, STEP 파일 업로드")
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"w-80 m-auto mt-2 cs-caption\" data-v-44f9c9ce><i class=\"fi fi-br-exclamation mr-1\" data-v-44f9c9ce></i><div class=\"text-left\" data-v-44f9c9ce><p style=\"line-height:1.3;\" data-v-44f9c9ce>최대 10개 모델 업로드 가능합니다.<br data-v-44f9c9ce><span class=\"hidden md:inline\" data-v-44f9c9ce>해당 영역에 드래그&amp;드롭으로 업로드 가능합니다.</span></p></div></div>", 1)
const _hoisted_10 = { class: "mt-6 px-5 md:mt-8" }
const _hoisted_11 = {
  class: "text-placeholder leading-4",
  style: {"font-size":"0.95rem"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fi fi-sr-cloud-upload-alt drop-area-icon text-white text-4xl md:text-7xl" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "drop-area-desc text-white" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-semibold md:text-lg" }, "파일을 업로드하려면 여기에 드롭하세요.")
], -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "items-center justify-center w-full h-full rounded-md"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bounding-loader-fail-text text-center bg-black-500" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-white md:text-xl" }, "시스템 설정이 필요합니다, 관리자에게 문의해주세요.")
], -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 2,
  class: "items-center justify-center bounding-loader rounded-md"
}
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div class=\"loader-boxs\" data-v-44f9c9ce><div class=\"scene\" data-v-44f9c9ce><div class=\"plane\" data-v-44f9c9ce><div class=\"cube cube--0\" data-v-44f9c9ce><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div></div><div class=\"shadow shadow--0\" data-v-44f9c9ce></div><div class=\"cube cube--1\" data-v-44f9c9ce><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div></div><div class=\"shadow shadow--1\" data-v-44f9c9ce></div><div class=\"cube cube--2\" data-v-44f9c9ce><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div></div><div class=\"shadow shadow--2\" data-v-44f9c9ce></div><div class=\"cube cube--3\" data-v-44f9c9ce><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div></div><div class=\"shadow shadow--3\" data-v-44f9c9ce></div><div class=\"cube cube--4\" data-v-44f9c9ce><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div></div><div class=\"shadow shadow--4\" data-v-44f9c9ce></div><div class=\"cube cube--5\" data-v-44f9c9ce><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div></div><div class=\"shadow shadow--5\" data-v-44f9c9ce></div><div class=\"cube cube--6\" data-v-44f9c9ce><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div></div><div class=\"shadow shadow--6\" data-v-44f9c9ce></div><div class=\"cube cube--7\" data-v-44f9c9ce><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div><div class=\"cube__side\" data-v-44f9c9ce></div></div><div class=\"shadow shadow--7\" data-v-44f9c9ce></div></div></div></div>", 1)
const _hoisted_20 = { class: "bounding-loader-text text-center" }
const _hoisted_21 = {
  key: 0,
  class: "md:text-xl"
}
const _hoisted_22 = {
  class: "mt-5 md:w-10 md:mt-0 md:px-2",
  style: {"min-width":"330px"}
}
const _hoisted_23 = { class: "estimate-content overflow-hidden border border-line border-b-2 rounded-md md:sticky" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex relative items-center justify-center py-3 bg-black" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "sub-logo",
    src: _imports_0
  })
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "px-7 py-4 bg-deepgray text-gray text-center text-sm leading-5" }, [
  /*#__PURE__*/_createElementVNode("p", null, "3D모델을 자동으로 분석하여 프린팅시"),
  /*#__PURE__*/_createElementVNode("p", null, "위험요소 및 견적을 자동으로 분석합니다.")
], -1))
const _hoisted_26 = { class: "flex justify-between px-7 bg-white border-b border-line" }
const _hoisted_27 = { class: "flex justify-between w-full py-5 font-normal" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-placeholder" }, "총 모델", -1))
const _hoisted_29 = { class: "text-right" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-5 mr-5 border-l border-line" }, null, -1))
const _hoisted_31 = { class: "flex justify-between w-full py-5 font-normal" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-placeholder" }, "총 수량", -1))
const _hoisted_33 = { class: "text-right" }
const _hoisted_34 = { class: "py-6 px-7 bg-white border-b border-line" }
const _hoisted_35 = { class: "flex justify-between font-normal" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-placeholder" }, "출력 비용", -1))
const _hoisted_37 = { class: "text-right" }
const _hoisted_38 = { class: "flex justify-between mt-6 font-normal" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-placeholder" }, "배송 비용", -1))
const _hoisted_40 = { class: "text-right" }
const _hoisted_41 = { class: "py-4 px-7 bg-white" }
const _hoisted_42 = { class: "font-normal mt-3 md:mt-3 md:flex md:justify-between" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1 font-semibold" }, "총 비용 (예상)", -1))
const _hoisted_44 = { class: "mt-2 text-right text-4xl text-second font-bold md:mt-0" }
const _hoisted_45 = { class: "pt-5 pb-5 px-7 bg-white" }
const _hoisted_46 = ["disabled"]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xl font-bold" }, "견적 문의하기", -1))
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = { class: "flex justify-end pt-2 pb-5 px-7 bg-white" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-9 m-auto"
}, null, -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "block mt-1 text-xs font-medium" }, " AR Viewer", -1))
const _hoisted_52 = [
  _hoisted_50,
  _hoisted_51
]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "w-full p-4 bg-black text-center text-lightgray text-xs md:text-sm leading-4",
  style: {"position":"fixed","left":"0px","bottom":"0px"}
}, " 본 시스템에 대한 권리는 (주)하이쓰리디에게 있으며 무단 복제, 링크 연동, AI 훈련에 사용시 법적 조치 될 수 있습니다. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_client_model = _resolveComponent("client-model")!
  const _component_modal_analysis = _resolveComponent("modal-analysis")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      ref: "inputFileData",
      type: "file",
      multiple: "",
      charset: "utf-8",
      accept: ".stp, .step, .stl",
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeInputFile && _ctx.changeInputFile(...args)))
    }, null, 544), [
      [_vShow, false]
    ]),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.models, (model) => {
          return (_openBlock(), _createBlock(_component_client_model, {
            key: model.id,
            model: model
          }, null, 8, ["model"]))
        }), 128)),
        _createElementVNode("div", {
          ref: "dragDropContainer",
          class: "relative w-full py-10 border border-line border-b-2 rounded-md bg-white text-center upload-area",
          onDragenter: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDragEnter && _ctx.onDragEnter(...args)), ["prevent"])),
          onDragend: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDragEnd && _ctx.onDragEnd(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: _normalizeClass(["w-80 m-auto cs-btn cs-pd-btn-sm", _ctx.isEstimateSubmit ? 'cs-btn-second' : 'cs-btn-disabled']),
              disabled: !_ctx.isEstimateSubmit,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.inputFileFocus && _ctx.inputFileFocus(...args)))
            }, _hoisted_8, 10, _hoisted_6),
            _hoisted_9
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("p", _hoisted_11, [
              _createTextVNode(" 업로드하신 파일은 암호화되어 보관됩니다. 업로드하시면 "),
              _createElementVNode("button", {
                class: "text-second font-semibold cursor-pointer",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onTerm && _ctx.onTerm(...args)))
              }, "이용 약관"),
              _createTextVNode("에 동의하신 것으로 간주합니다. ")
            ])
          ]),
          (_ctx.isDraging)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "drop-area",
                ref: "dropContent",
                id: "dropContent",
                onDrop: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)), ["prevent"])),
                onDragenter: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
                onDragover: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
                onDragleave: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDragLeave && _ctx.onDragLeave(...args)), ["stop"]))
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["drop-area-inner", {active: _ctx.isDraging}])
                }, _hoisted_14, 2)
              ], 544))
            : _createCommentVNode("", true),
          (_ctx.AnalysisStatus.Fail === _ctx.isEnabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
            : (_ctx.AnalysisStatus.Pass !== _ctx.isEnabled)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, [
                    (_ctx.AnalysisStatus.Processing === _ctx.isEnabled)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_21, "초기화 중 입니다, 잠시만 기다려주세요."))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
        ], 544)
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.models.length) + " 개", 1)
            ]),
            _hoisted_30,
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.totalModelQuantiy) + " 개", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.numberToComma(_ctx.estimate.modelCost ? _ctx.estimate.modelCost : 0)) + " 원", 1)
            ]),
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.shippingCost) + " 원", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _hoisted_43,
              _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.totalCost) + "원", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("button", {
              class: _normalizeClass(["w-full cs-btn cs-pd-btn", _ctx.models.length && _ctx.isEstimateSubmit ? 'cs-btn-base' : 'cs-btn-disabled']),
              disabled: !_ctx.isEstimateSubmit,
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
            }, _hoisted_48, 10, _hoisted_46)
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("button", {
              class: "w-24 cs-btn cs-btn-default py-3 px-2 text-center",
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onGoAR && _ctx.onGoAR(...args)))
            }, _hoisted_52)
          ])
        ])
      ])
    ]),
    _hoisted_53,
    (_ctx.isVisibleViewer)
      ? (_openBlock(), _createBlock(_component_modal_analysis, {
          key: 0,
          model: _ctx.currentModel
        }, null, 8, ["model"]))
      : _createCommentVNode("", true)
  ]))
}